/*
 * Copyright (C) 2018 BarD Software s.r.o
 */

import {Vue, Component} from 'vue-facing-decorator';
import {timestampAdaptiveString} from '../utils/Time';

import $ from 'jquery';

export interface BellNotificationMethods {
    hasEvents(): boolean;
    push(e: any);
    hideAlertCircle();
    deferredClean();
}

const eventLimit = 5;

@Component
export default class BellNotification extends Vue {
    public notifications: MutableList<Notification> = [];

    public mounted() {
        $(this.$el).on('show.bs.dropdown', () => this.hideAlertCircle());
    }

    public hasEvents(): boolean {
        return this.notifications.length > 0;
    }

    public push(e: Notification) {
        $('#bell-box-dropdown .fa-circle').removeClass('d-none');
        this.notifications.unshift(e);
        if (this.notifications.length > eventLimit) {
            this.notifications.pop();
        }
    }

    public hideAlertCircle() {
        $('#bell-box-dropdown .fa-circle').addClass('d-none');
    }

    public timestampString(ts): string {
        return timestampAdaptiveString(ts).str;
    }

    public deferredClean() {}
}
